import type { ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';

const PAGE_POSITION = 'Homepage Article Headlines';

type Props = { items: ArticleCardType[] };

export default function Headlines({ items }: Props) {
  const [hero, sideA, sideB] = items;
  if (!hero || !sideA || !sideB) return null;

  return (
    <div className="w-full bg-grey-tile">
      <div className="mx-auto max-w-desktop py-10 md:py-20">
        <div className="no-scrollbar flex items-center gap-2 overflow-x-scroll max-md:px-4 md:items-center md:gap-6">
          <ArticleCard
            className="order-1 shrink-0 max-md:w-[285px] md:order-2 md:flex-1 md:self-stretch"
            item={hero}
            name="LATEST_NEWS"
            pagePosition={PAGE_POSITION}
            variant="4/5-text-over"
          />
          <ArticleCard
            className="order-2 hidden shrink-0 max-md:w-[285px] md:order-1 md:block md:flex-1"
            item={sideA}
            name="LATEST_NEWS"
            pagePosition={PAGE_POSITION}
            variant="16/9-text-under"
          />
          <ArticleCard
            className="order-3 hidden shrink-0 max-md:w-[285px] md:order-3 md:block md:flex-1"
            item={sideB}
            name="LATEST_NEWS"
            pagePosition={PAGE_POSITION}
            variant="16/9-text-under"
          />

          {/* Mobile variants */}
          <ArticleCard
            className="order-2 shrink-0 max-md:w-[285px] md:order-1 md:hidden md:flex-1"
            item={sideA}
            name="LATEST_NEWS"
            pagePosition={PAGE_POSITION}
            variant="4/5-text-over"
          />
          <ArticleCard
            className="order-3 shrink-0 max-md:w-[285px] md:order-3 md:hidden md:flex-1"
            item={sideB}
            name="LATEST_NEWS"
            pagePosition={PAGE_POSITION}
            variant="4/5-text-over"
          />
        </div>
      </div>
    </div>
  );
}
